module.exports = __webpack_public_path__ + "img/ICONPROVIDE.610abcb3.webp";